import React, { Component } from "react";
import PropTypes from "prop-types";
import Investment from "./investment";
import Util from "../../../common/util";
import InvestmentForm from "./investment_form";

class MyInvestmentPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditMode: false
    };
  }

  handleEditModeLinkClick = () => {
    this.setState(prevState => (
      { isEditMode: !prevState.isEditMode }
    ));
  };

  render () {
    const { isEditMode } = this.state;
    const { is_angel, investments } = this.props;

    return is_angel === true && (
      <section className='row d-flex justify-content-center' id='investments' name='investments'>
        <div className='col-12 col-sm-10'>
          <h2>
            INVESTMENTS
            <button type='button' className='btn-profile-edit' onClick={this.handleEditModeLinkClick}>
              <span className='d-none d-md-inline'>投資先の</span>
              { isEditMode === true ? "編集完了" : "編集" }
            </button>
          </h2>

          { isEditMode === true && (
            <InvestmentForm
              {...this.props}
              handleEditModeLinkClick={this.handleEditModeLinkClick}
            />
          )}

          { investments.length > 0 && (
            <div className='row'>
              {Util.arrayInGroupOfArray(Object.assign([], investments), 3).map(group => {
                return (
                  group.map(investment => {
                    return (
                      <Investment
                        {...this.props}
                        key={investment.id}
                        company={investment}
                        isEditMode={isEditMode}
                      />
                    );
                  })
                );
              })}
            </div>
          )}

          { investments.length == 0 && isEditMode === false && (
            <button type='button' className='container content-null' onClick={this.handleEditModeLinkClick}>
              <p>
                <i className="fas fa-edit mr-1" />
                投資先の情報を追加しましょう
              </p>
            </button>
          )}
        </div>
      </section>
    );
  }
}

MyInvestmentPage.propTypes = {
  is_angel: PropTypes.bool.isRequired,
  investments: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default MyInvestmentPage;
